import React from "react";
import logo from "../assets/images/logo_dark.png";
import { Col, Container, Row } from "reactstrap";
import { Link, NavLink } from "react-router-dom";

const ListCard = (props) => {
  return (
    <React.Fragment>
          <div className="text-white fs-3 fw-bold">{props.title}</div>
    </React.Fragment>
  );
}

const ListData = [
  {
    title: "Home",
    link:"/"
  },
  {
    title: "Servizi",
    link:"/servizi"
  },
  {
    title: "Contattaci",
    link:"/contatti"
  },
];

const ListIconData = [
  {
    iconClass: "mdi mdi-facebook",
    link:'https://www.facebook.com/profile.php?id=100028974956265&fref=ts'
  }
];

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="bg-footer">
        <Container>
          <Row className="justify-content-center align-items-center">
            <Col lg={3} sm={12} className="text-center">
              <div className="mt-4">
                <Link to="/">
                  <img src={logo} alt="" height="50" />
                </Link>
                <p className="text-white-50 mt-3 pt-2 mb-0 fs-4">
                  L'azienda leader dei generatori di corrente
                </p>
                <div className="mt-4">
                  <ul className="list-inline footer-social">
                    {/* Footer Icon Component Start */}
                    {ListIconData.map((item, key) => (
                      <li className="list-inline-item" key={key}>
                        <Link to="https://www.facebook.com/profile.php?id=100028974956265&fref=ts">
                          <i className={item.iconClass} style={{fontSize:30}}></i>
                        </Link>
                      </li>
                    ))}
                    {/* Footer Icon Component End */}
                  </ul>
                </div>
              </div>
            </Col>

            {/* Footer List Start*/}
            <Col lg={9} sm={12} className="text-center">
              <div className="d-flex justify-content-between align-items-center">
              {ListData.map((item, key) => (
                <NavLink to={item.link} className="col-4 text-center">
                <ListCard
                  key={key}
                  title={item.title}
                /></NavLink>
              ))}
              </div>
            </Col>
            {/* Footer List End*/}

          </Row>
        </Container>
      </footer>
    </React.Fragment>
  );
}

export default Footer;
